module.exports = __webpack_public_path__ + "img/avatar7.8248173e.png";